module.exports = __webpack_public_path__ + "img/aidimme-color.2947dcdc.png";